// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import AlertWrapper from './AlertWrapper';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const NeedReloadAlert = ({ show }) => {
  const reloadPage = event => {
    event.preventDefault();
    window.location.reload();
  };

  return (
    <AlertWrapper show={show}>
      <a href='/' onClick={reloadPage}>
        <span role='img' aria-label='lightning'>
          ⚡️
        </span>
        Click here to refresh BAT and see the new changes!
      </a>
    </AlertWrapper>
  );
};

export default NeedReloadAlert;
